// src/services/analiseApiService.js
//
// Helper de API dedicado para os endpoints de Análise de Campanha.
// Estrutura idêntica ao apiService.js, apenas com a baseURL diferente.
//
// Backend Worker: precisa ter o alias "analise" mapeado para o grupo Xano da feature.
// URL final: https://api.sobevenda.com.br/api-proxy/analise/<endpoint>
//
import axios from "axios";
import { toast } from "react-toastify";

const API_BASE_URL = "https://api.sobevenda.com.br/api-proxy/analise";

const analiseApi = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Interceptor de REQUEST - adiciona o token em todas as requisições
analiseApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("sobevenda_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor de RESPONSE - detecta quando o token expirou
analiseApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response &&
      (error.response.status === 401 || error.response.status === 403)
    ) {
      const message =
        error.response.data?.message ||
        "Sessão expirada. Faça login novamente.";

      localStorage.removeItem("sobevenda_token");
      localStorage.removeItem("sobevenda_user_id");

      toast.error(message);
      window.location.href = "/login";
    }

    return Promise.reject(error);
  }
);

export default analiseApi;